

export function getLinkInstallments(installmentListWithBrand) {


    let installmentList = [];
    var maxInstallment = 0;
    for (let i = 0; i < installmentListWithBrand.length; i++) {
        const element = installmentListWithBrand[i];

        var filteredList = element.installmentList?.filter(function (el) {
            return el.status == true
        });
        var tempMaxInstallment = Math.max(...filteredList.map(o => o.month))

        if (tempMaxInstallment > maxInstallment) {
            maxInstallment = tempMaxInstallment;
            installmentList = filteredList;
        }
    }
    return installmentList;
}